import { HttpErrorResponse } from '@angular/common/http';
import { Component, computed, effect, signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs';
import { MainStore } from 'src/app/common/main.store';
import { UserService } from 'src/app/services/user.service';
import { ContinuousLoadingBarComponent } from '../common/general/continuous-loading-bar/continuous-loading-bar.component';
import { TopMenuComponent } from '../menu/top-menu/top-menu.component';
import { TopSubMenuComponent } from '../menu/top-sub-menu/top-sub-menu.component';


@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrl: './main-layout.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ContinuousLoadingBarComponent, TopMenuComponent, TopSubMenuComponent, RouterOutlet]
})
export class MainLayoutComponent {

  showLoader: boolean = false;
  displayDataBeingFetched = signal('');
  currentUser: any;

  isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal

  // URLs where the top sub menu should be hidden
  private readonly hideSubMenuUrls = ['/synchronization/'];

  private currentUrl = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => (event as NavigationEnd).url)
    ),
    { initialValue: this.router.url }
  );

  shouldHideSubMenu = computed(() => {
    const url = this.currentUrl();
    return this.hideSubMenuUrls.some(hideUrl => url?.startsWith(hideUrl));
  });

  constructor(
    public router: Router,
    private store: MainStore,
    private userService: UserService
  ) { }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData() {
    // console.log('(loaddata) Url: ' + this.router.url);
    this.currentUser = this.store.currentUser.get();
    if (!this.currentUser.name || this.currentUser.name === '') { 
      this.displayDataBeingFetched.set('Indlæser brugerdata');
      this.showLoader = true;
      await this.userService.getUserInfo().then((result: boolean) => {
        if (!result) {
          this.router.navigate(['404']);
        }
        else {
          this.currentUser = this.store.currentUser.get();
        }
      })
        .catch((error) => {
          this.store.error.set(error);
          this.router.navigate(['error']);
        })
        .finally(() => {
          ;
          this.showLoader = false;
        });
    }
    if (this.router.url === '/') {
      this.router.navigate(['home']);
    }
  }
}
